<template>
  <div>
    <div>
      <h2 class="block-headline">
        <a :href="detailUrl">TOP 3 okresy s nejmenším podílem osob v exekuci</a>
      </h2>
    </div>
    <div class="block-content tiny-text">
      <div v-for="item in slicedItems(-1).reverse()">
        <p><strong>{{ item.label }}</strong></p>
        <p>{{ item.value }}</p>
      </div>
      <div class="stats-status mt-2">
        <div />
        <time>{{ updatedAtFormatted }}</time>
      </div>
    </div>
    <div class="block-bottom">
      <div />
      <v-btn
        :href="detailUrl"
        text
        x-small
      >
        Podrobnosti
      </v-btn>
    </div>
  </div>
</template>

<script>
import stats from '../../json/top_3_lowest.json'
import statsMixin from '../statsMixin'

export default {
  name: 'VCardTop3LowestHomepage',
  mixins: [
    statsMixin
  ],
  props: {
    detailUrl: {
      type: String,
      default: () => {
        return '/statistiky/top-3-nejmensi.html'
      }
    }
  },
  data () {
    return {
      items: stats.data,
      meta: stats.meta
    }
  },
  methods: {
    createChart () {
      // these stats have no chart
    }
  }
}
</script>
